import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import VirtualizedTable from "../components/VirtualizeTable";
import ModalityDelete from "./ModalityDelete";
import { MRT_ColumnDef } from "material-react-table";
import { IconEdit, IconTrash } from "@tabler/icons-react";

const ModalityTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    name: string;
    description?: string;
    createdAt: string | Date;
    status: boolean;
  }>;
  refetch: () => void;
}) => {
  const navigate = useNavigate();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [id, setId] = useState("");

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "name",
        header: "Nome",
      },
      {
        accessorKey: "description",
        header: "Descrição",
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => navigate(`/modality-details/${row.original.id}`)}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <ModalityDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        onAction={refetch}
      />
    </>
  );
};

export default ModalityTableComponent;
